// extracted by mini-css-extract-plugin
export var standaloneTable = "_fu-0";
export var standaloneTableWithBodyFill = "_fu-1";
export var withExtraHeader = "_fu-2";